var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Slidebar',{attrs:{"autoClose":true},on:{"closeMe":_vm.closeSlidebar}},[_c('h4',[_vm._v("Starfsmannaleit")]),_c('br'),_c('StaffSearch',{attrs:{"slidebar":true},on:{"changeStaff":_vm.closeSlidebar}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }